import moment from "moment/moment";

export const getQuantityInLoose = (qty, loose, divisor) => {
  let updatedQty = parseInt(qty) || 0;
  let updatedLoose = parseInt(loose) || 0;
  let updatedDivisor = parseInt(divisor) || 1;
  return updatedQty * updatedDivisor + updatedLoose;
};
export const createProductData = (data) => {
  return {
    medicineId: data.medicineId,
    // barcode: data.batch.barcode,
    divisor: data?.divisor,
    // currQuantity: data.batch.currQuantity,
    // currLoose: data.batch.currLoose,
    // perSKU: data.batch.mrp,
    // batchExpiry: data.batch.batchExpiry,
    rack: data.rack,
    rack1: data?.rack1,
    medicineNameDetailed: data.medicineNameDetailed,
    // costPrice: data.batch.costPrice,
    isLoose: data.isLoose,
    // enteredQty: data?.enteredQty || 1,
    // enteredLoose: data?.enteredLoose || 0,
    // checked: false,
    // isScan: data?.isScan || false,
    ...data,
  };
};

export const createSaveStockRowData = (data) => {
  let difference =
    (getQuantityInLoose(data.enteredQty, data.enteredLoose, data.divisor) -
      getQuantityInLoose(data.currQuantity, data.currLoose, data.divisor)) /
    data.divisor;
  return {
    expectedQuantity: data.currQuantity,
    expectedLoose: data.currLoose,
    actualQuantity: data.enteredQty,
    actualLoose: data.enteredLoose || 0,
    batchId: data.batchId,
    medicineId: data.medicineId,
    difference: difference,
    // differenceInAmount: difference * parseInt(data.perSKU),
    isScan: data?.isScan,
    isAddBatch: false,
    remarks: data?.remarks || null,
    isContra: false,
    totalAuditedMrp:
      (getQuantityInLoose(data.enteredQty, data.enteredLoose, data.divisor) /
        data.divisor) *
      parseInt(data.perSKU),
    totalAuditedCostPrice:
      (getQuantityInLoose(data.enteredQty, data.enteredLoose, data.divisor) /
        data.divisor) *
      parseInt(data.costPrice),
    totalExpectedMrp:
      (getQuantityInLoose(data.currQuantity, data.currLoose, data.divisor) /
        data.divisor) *
      parseInt(data.perSKU),
    totalExpectedCostPrice:
      (getQuantityInLoose(data.currQuantity, data.currLoose, data.divisor) /
        data.divisor) *
      parseInt(data.costPrice),
  };
};

export const createSaveStockData = (products, data) => {
  let differenceInAmount = 0;
  let totalMrp = 0;
  let totalCostPrice = 0;
  let totalExpectedMrp = 0;
  let totalExpectedCostPrice = 0;
  products.forEach((prd) => {
    differenceInAmount += parseInt(prd.differenceInAmount);
    totalMrp += parseInt(prd.totalAuditedMrp);
    totalCostPrice += parseInt(prd.totalAuditedCostPrice);
    totalExpectedMrp += parseInt(prd.totalExpectedMrp);
    totalExpectedCostPrice += parseInt(prd.totalExpectedCostPrice);
  });
  return {
    // differenceInAmount,
    totalMrp,
    totalCostPrice,
    totalExpectedMrp,
    totalExpectedCostPrice,
    isStockAdjusted: data?.adjustStock || false,
    auditor: data.auditorName,
    remarks: data?.remarks,
    startTime: data?.startDate,
    endTime: moment().toISOString(),
    businessDate: moment().toISOString(),
  };
};
